module.exports = __webpack_public_path__ + "assets/tooltip_info-3e0eea.svg";